export default function () {
    const collapsibles = document.querySelectorAll('.collapsible__title');

    if (collapsibles) {
        collapsibles.forEach((collapsible)=>{
            collapsible.addEventListener('click', (e) =>{
                openCollapsible(e.target);
            });
        });
    }

    function scrollToTargetAdjusted(el){
        const element = el;
        const headerOffset = 200;
        const elementPosition = element.getBoundingClientRect().top;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offsetPosition = scrollTop + elementPosition - headerOffset;
    
        window.scrollTo({
             top: offsetPosition,
             behavior: "smooth"
        });
    }

    if (location.hash) {
        const thisHash = location.hash.substring(1);
        if (!thisHash.startsWith('&') ) {
            const jobPost = document.querySelector(`#${thisHash}`);
            if (jobPost) {
                setTimeout(function() {
                    window.scrollTo(0, 0);
                }, 1);
                openCollapsible(jobPost);
                console.log(jobPost);
                setTimeout(function(){ 
                    scrollToTargetAdjusted(jobPost);
                }, 2500);
            }
        }
    }

    function openCollapsible(collapsible) {
        collapsible.classList.toggle('active');
        const content = collapsible.nextElementSibling;
        if (content.style.maxHeight) {
            content.style.maxHeight = null;
        } else {
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    }
}